import { useContext } from 'react';

import { RichTextEditorContext } from './rich-text-editor-provider';

function useRichTextEditor() {
  const context = useContext(RichTextEditorContext);
  if (context === undefined) {
    throw new Error('useEditor must be used within EditorProvider');
  }
  return context;
}

export { useRichTextEditor };
